
      export default defineNuxtPlugin(() => {
        const runtime = useRuntimeConfig();

        let src = 'https://lf1-cdn-tos.bytegoofy.com/obj/iconpark/icons_29472_271.9b3756aa5fd9b48c65daa1bae5d92c1e.js';

        if(false) {
          if(runtime.app.cdnURL){
            src = runtime.app.cdnURL + '/undefined';
          }else{
            src = '/undefined';
          }
        }

        useHead({
          script: [{
            src,
            defer: true
          }],
        });
      })
      